import { useCallback, useEffect, useRef, useState } from "react";

import TitleAnnulmentsPanel from "../../components/titleAnnulments/TitleAnnulmentsPanel";
import { fetchProductAccessCompanies } from "./productAccessApi";
import { fetchTitleAnnulments, titleAnnulmentsApi } from "./titleAnnulmentsApi";

const TitleAnnulments = () => {
  const [companies, setCompanies] = useState([]);
  const [companyId, setCompanyId] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const requestRef = useRef(0);

  const load = useCallback(async (selectedCompanyId) => {
    const requestId = requestRef.current + 1;
    requestRef.current = requestId;
    setLoading(true);
    setError(null);
    const result = await fetchTitleAnnulments(selectedCompanyId);
    if (requestRef.current !== requestId) return;
    if (result.ok) setData(result.body);
    else {
      setData(null);
      setError(result.body?.message || "Não foi possível carregar os títulos anulados.");
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    let active = true;
    fetchProductAccessCompanies()
      .then((payload) => {
        if (!active) return;
        const available = (payload.companies || []).filter((company) => company.state !== "inactive");
        setCompanies(available);
        setCompanyId(available[0]?._id || "");
        if (available.length === 0) setLoading(false);
      })
      .catch((requestError) => {
        if (!active) return;
        setError(requestError?.message || "Não foi possível carregar as empresas.");
        setLoading(false);
      });
    return () => { active = false; };
  }, []);

  useEffect(() => {
    if (companyId) load(companyId);
  }, [companyId, load]);

  const reload = useCallback(() => { if (companyId) load(companyId); }, [companyId, load]);

  return <main className="director-page governance-page">
    <header className="director-page__header">
      <div>
        <span className="director-eyebrow">Backoffice · administração</span>
        <h1>Títulos anulados</h1>
        <p>Títulos do Sienge que saem do Ampli Obras e da Diretoria. O Sienge não muda.</p>
      </div>
      <div className="director-filter-field">
        <label htmlFor="title-annulments-company">Empresa</label>
        <select id="title-annulments-company" value={companyId} onChange={(event) => setCompanyId(event.target.value)}>
          {companies.map((company) => <option key={company._id} value={company._id}>{company.name}</option>)}
        </select>
      </div>
    </header>
    {error && <div className="director-state director-state--error" role="alert">{error}</div>}
    {loading && !data && <div className="director-state" role="status">Carregando títulos anulados…</div>}
    {data && <TitleAnnulmentsPanel
      key={companyId}
      variant="backoffice"
      data={data}
      reload={reload}
      api={titleAnnulmentsApi}
      companyId={companyId}
    />}
  </main>;
};

export default TitleAnnulments;
